/**
 * Utility to detect if the user is on a mobile device.
 */
export const isMobileDevice = (): boolean => {
    // First check if this is running in a browser
    if (typeof navigator === 'undefined') return true;

    // Common patterns for mobile user agents
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

    // Check userAgent
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Check if the userAgent matches mobile patterns
    if (mobileRegex.test(userAgent)) return true;

    return false;
}